import { BaseResourceApiService } from '@shared/services/BaseResourceApiService';

class TaskServiceClass extends BaseResourceApiService {
  constructor(opts) {
    super(opts);
  }
  getList(campaign_id, params = {}) {
    return this.http.get(`${campaign_id}/tasks`, { params: params });
  }

  createItem(campaign_id, numbers = {}) {
    return this.pure_http.post(`informer/numbers`, { campaign_id: parseInt(campaign_id), numbers });
  }

  removeItem(campaign_id, task_id) {
    return this.http.delete(`${campaign_id}/tasks/${task_id}`);
  }
  removeItemModal({ campaign_id, task_id }) {
    return this.removeItem(campaign_id, task_id);
  }
}

export const TaskService = new TaskServiceClass({
  api_version: 2,
  resource: 'informer/campaigns'
});
